import { render, staticRenderFns } from "./FacebookIntegracoes.vue?vue&type=template&id=fb1fd130&scoped=true&"
import script from "./FacebookIntegracoes.vue?vue&type=script&lang=js&"
export * from "./FacebookIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./FacebookIntegracoes.vue?vue&type=style&index=0&id=fb1fd130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1fd130",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
